import React, { useState, useContext, useEffect } from 'react';
import api from '../utils/api';
import './styles/PaymentReportMonthlyPage.css';
import AuthContext from '../context/AuthContext';
import moment from 'moment';

const ExtraTimeMonthlyReportPage = () => {
    const { user } = useContext(AuthContext);
    const [extraTimeData, setExtraTimeData] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [dateMonth, setDateMonth] = useState('');
    const [teacher, setTeacher] = useState({});
    const [errorMessage, setErrorMessage] = useState(''); // State untuk menyimpan pesan kesalahan

    useEffect(() => {
        api.post('/teacher/getTeacher', {
            data: {
                username: user.username
            }
        })
        .then(response => {
            const teacherData = response.data.data;
            setTeacher(teacherData);
        })
        .catch(error => console.error('Error fetching teacher list:', error));
    }, [user.username]);


    const handleSearch = async () => {
        const [year, month] = dateMonth.split('-');
        if (!teacher.teacher_name || !year || !month) {
            alert('Silakan isi nama guru, bulan, dan tahun!');
            return;
        }

        try {
            const response = await api.post('/teacher/extraTime/monthly/report', {
                data: {
                    teacherData: {
                        teacher_name: searchName ? searchName : teacher.teacher_name,
                        dateMonth: dateMonth
                    }   
                }
            });

            // Periksa apakah data attendance ada
            if (!response.data.data || response.data.data.length === 0) {
                setErrorMessage('Extra time data not found');
                setExtraTimeData([]); // Reset data attendance
            } else {
                setExtraTimeData(response.data.data);
                setErrorMessage(''); // Reset pesan kesalahan jika data ditemukan
            }
        } catch (error) {
            console.error('Error fetching extra time data:', error);
            setErrorMessage('Extra time data not found');
        }
    };

    return (
        <div className="inventory-page">
            <div className="page-title">Monthly Extra Time Report</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Teacher Name</label>
                                    </td>
                                    {teacher.User?.Role?.name === 'teacher' ? 
                                    <td>
                                        <input 
                                            type="text" 
                                            value={teacher.teacher_name || ''} 
                                            readOnly={true}
                                        />
                                    </td>
                                    :
                                    <td>
                                        <input 
                                            type="text" 
                                            value={searchName} 
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Date Month</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="month"
                                            name="dateMonth"
                                            value={dateMonth} 
                                            onChange={e => setDateMonth(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} {/* Tampilkan pesan kesalahan */}
                    </div>
                </div>
                <div className="section">
                    <div className="inventory-list">
                        <table>
                            <thead>
                                <tr>
                                    <th class="no-column">No</th>
                                    <th><center>Extra Time Date</center></th>
                                    <th><center>Extra Time Type</center></th>
                                    <th><center>Extra Time Amount</center></th>
                                    <th><center>Extra Time Description</center></th>
                                </tr>
                            </thead>
                            <tbody>
                                {extraTimeData.map((data, index) => (
                                    <tr key={data.extra_time_id}>
                                        <td class="no-column">{index+1}</td>
                                        <td>{moment(data.extra_time_date).format('DD MMMM YYYY')}</td>
                                        <td>{data.Type.type_name}</td>
                                        <td>{data.amount}</td>
                                        <td>{data.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
          
            
            
        </div>
    );
};

export default ExtraTimeMonthlyReportPage;
